export default __webpack_public_path__ + "static/media/grinning.95c91877.svg";